export const convertUTCToLocal = utcDateString => {
  if (!utcDateString) return null // Handle null or undefined input

  // Create Date object from UTC string
  const utcDate = new Date(utcDateString)

  const year = utcDate.getUTCFullYear()
  const month = utcDate.getUTCMonth()
  const day = utcDate.getUTCDate()

  const localDate = new Date(year, month, day)

  return localDate.toLocaleDateString()
}

export const convertISOToLocal = isoDateString => {
  if (!isoDateString) return null // Handle null or invalid input
  const date = new Date(isoDateString)
  return date.toLocaleString()
}
